{
	"title": "Commentaires",
	"statuses": {
		"inValidation": "En validation",
		"rejected": "Rejeté",
		"assured": "Assuré",
		"flagged": "Signalé",
		"resolved": "Résolu"
	}
}
